module.exports = __webpack_public_path__ + "img/kanban02.289c88d8.png";